export const constants = {
  baseUrl: 'https://iyns.in',
  // baseUrl: 'http://localhost:4000',
};
